import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getManagerPanel } from '../../services/migration/personnelDataService';

export interface ManagerCashPermissions {
  canAddExpense: boolean;
  canViewMovements: boolean;
  loaded: boolean;
}

const NONE: ManagerCashPermissions = { canAddExpense: false, canViewMovements: false, loaded: false };

/** Kural backend'deki ManagerPanelPermissions.IsGranted(cash_expense / cash_movements) ile aynıdır. */
export const resolveCashPermissions = (settings: any): Omit<ManagerCashPermissions, 'loaded'> => {
  const s = settings || {};
  const subs = s['cash_subPermissions'] || {};
  const cashOpen = s['cash'] === true;
  return {
    canAddExpense: cashOpen && subs['cash_expense'] === true,
    canViewMovements: cashOpen && subs['cash_movements'] === true,
  };
};

/** Şube yöneticisinin Kasa alt yetkileri. `enabled` false ise istek atılmaz. */
export const useManagerCashPermissions = (enabled: boolean): ManagerCashPermissions => {
  const { currentUser } = useAuth();
  const [perms, setPerms] = useState<ManagerCashPermissions>(NONE);

  useEffect(() => {
    if (!enabled || !currentUser?.uid) {
      setPerms(NONE);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const mp = await getManagerPanel(currentUser.uid);
        if (cancelled) return;
        setPerms({ ...resolveCashPermissions(mp.found ? mp.settings : null), loaded: true });
      } catch (e) {
        console.warn('[useManagerCashPermissions] managerPanel okunamadı:', e);
        if (!cancelled) setPerms({ ...NONE, loaded: true });
      }
    })();
    return () => { cancelled = true; };
  }, [enabled, currentUser?.uid]);

  return perms;
};
